import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { initializeSessionHandling } from './session';

import './assets/main.css';

initializeSessionHandling(router);
createApp(App).use(router).mount('#app');
